import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";
import { FaCalendarAlt, FaUsers } from "react-icons/fa";
import { useParams,useNavigate,useLocation } from "react-router-dom";
import he from "he";
import Nav from "../Nav";
import TravLadhak from "../TravLadhak";
import Footer from "../Footer";
import "./DetailBikePackage.css";

const DetailBikePackage = () => {
  const [activeDay, setActiveDay] = useState(1);
  const [detailData, setDetailData] = useState(null);
  const [relatedResorts, setRelatedResorts] = useState([]);
  const [persons, setPersons] = useState(1);
const [showModal, setShowModal] = useState(false);
const [showSuccessModal, setShowSuccessModal] = useState(false);
  
  const { id } = useParams();
   const navigate = useNavigate();
   const location = useLocation();
   
  const toggleDay = (day) => {
    setActiveDay((prevDay) => (prevDay === day ? null : day));
  };

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}AllPackages`);
        const result = await response.json();
        const allPackages = result?.data || [];
        console.log("dataaa-", allPackages);

        //  Filter hotels for the "relatedResorts"
        const filteredRelatedResorts = allPackages.filter(pkg =>
          pkg?.category?.name?.toLowerCase()?.includes("hotel") && pkg._id !== id
        ).slice(0, 4);
        console.log("filtrResorts", filteredRelatedResorts);
        setRelatedResorts(filteredRelatedResorts);


        const filteredBikes = allPackages.filter(pkg =>
          pkg?.category?.name?.toLowerCase().includes("bike")
        );

        const detailedBike = filteredBikes.find(bike =>
          bike?.id?.toString() === id
        );
        console.log("dd", detailedBike);
        setDetailData(detailedBike);
      } catch (error) {
        console.error("Failed to fetch bike package", error);
      }
    };

    fetchPackages();
  }, [id]);

  if (!detailData) return <p className="text-center mt-5">Loading package details...</p>;
  const handleBookClick = () => {
  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  if (isLoggedIn) {
    setShowModal(true); // show confirmation modal
  } else {
    // Save current path before redirecting
    sessionStorage.setItem("redirectAfterLogin", location.pathname);
    navigate("/login");
  }
};



const token = sessionStorage.getItem("token"); 
// console.log(token,id,(detailData?.price?.[0] * persons).toString());

  const handleConfirmBooking = async () => {
  setShowModal(false); // Close confirmation modal
  const payload = {
    token: token,
    PackageId: id,  // Or hardcoded if always "1"
    Amount: (detailData?.price* persons).toString(),
  };
 try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}new-booking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

    if (response.ok) {
      setShowSuccessModal(true); // Show success message
      console.log(response);
    } else {
      alert("Booking failed. Please try again.");
    }
  } catch (error) {
    console.error("Booking error:", error);
    alert("An error occurred. Please try again.");
  }
};

  return (
    <div className="container-fluid">
      <Nav />
      <div className="card border mb-4">
        <img
          src={detailData?.image[0] || "/placeholder.svg"}
          className="card-img-top rounded"
          alt={detailData?.name}
          style={{ maxHeight: "550px", objectFit: "cover" }}
        />

        <div className="card-body px-0">
          <div className="row justify-content-around">

            {/* LEFT SIDE - TOUR DETAILS */}
            <div className="col-md-8">
              <h2 className="fw-bold">{detailData?.name}</h2>
              <p
                className="text-muted small"
                dangerouslySetInnerHTML={{
                  __html: he.decode(detailData?.overview || ""),
                }}
              ></p>
              <div className="d-flex gap-3 mt-3 mb-4 flex-wrap">
               <span className="badge bg-light text-dark border">Trip Duration: {detailData?.days   || 'N/A'} days</span>
                <span className="badge bg-light text-dark border">Trip Type: {detailData?.category.name || 'Bike Ride'}</span>
                <span className="badge bg-light text-dark border">Destination: {detailData?.location || 'Unknown'}</span>
              </div>
            </div>

            {/* RIGHT SIDE - STACKED CARDS */}
            <div className="col-md-3 d-flex flex-column gap-3">
              <div className="card shadow-sm">
                <div
                  className="card-body d-flex flex-column justify-content-center align-items-center text-center"
                  style={{ padding: "1rem" }}
                >
                  <h6 className="card-title mb-3" style={{ fontSize: "1rem" }}>Details</h6>

                  <div className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between w-100">
                    <FaCalendarAlt className="text-secondary me-2" size={16} />
                    <span className="text-muted small me-2">Tour Date:</span>
                    <span style={{ fontSize: "0.85rem" }}>{detailData?.TourDate || 'TBD'}</span>
                  </div>

                  <div className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between w-100">
                    <FaUsers className="text-secondary me-2" size={16} />
                    <span className="text-muted small me-2">Days:</span>
                    <span style={{ fontSize: "0.85rem" }}>{detailData?.days || 'N/A'}</span>
                  </div>

                  {/* Persons Input */}
                  <div className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between w-100">
                    <FaUsers className="text-secondary me-2" size={16} />
                    <span className="text-muted small me-2">Persons:</span>
                    <input
                      type="number"
                      min="1"
                      value={persons}
                      onChange={(e) => setPersons(parseInt(e.target.value) || 1)}
                      className="form-control form-control-sm"
                      style={{ maxWidth: "60px" }}
                    />
                  </div>

                  {/* Price Display */}
                  <div className="border rounded p-2 w-100">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted small">Price / Person:</span>
                      <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                        ₹{detailData?.price || '---'}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted small">Total Price:</span>
                      <span className="fw-bold text-success" style={{ fontSize: "0.9rem" }}>
                        ₹{(detailData?.price * persons).toLocaleString()}
                      </span>
                    </div>
                    <button
                      className="btn btn-dark px-3 py-1 rounded-pill w-100"
                      style={{ fontSize: "0.8rem" }}
                        onClick={handleBookClick}
                    >
                      Book
                    </button>
                    {/* Modal */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Confirm Booking</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Do you want to proceed with booking this package?
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                          Cancel
                        </Button>
                        <Button variant="primary" onClick={handleConfirmBooking}>
                          Yes, Book Now
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Booking Confirmed</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Thank you for your booking! Our team will contact you shortly.
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-5">
  <div className="row justify-content-around align-items-start gx-4">
    <div className="col-md-8">
      <h3 className="mb-4 fw-bold text-uppercase">🗺️ Trip Itinerary</h3>
     
      <div className="accordion" id="itineraryAccordion">
  {detailData?.intinerary_details?.map((dayItem, index) => {
    const isActive = activeDay === index + 1;
    return (
      <div
        key={index}
        className={`accordion-item mb-3 border-0 shadow-sm rounded-3`}
      >
        <h2 className="accordion-header" id={`heading-${index}`}>
          <button
            className={`accordion-button px-4 py-3 ${
              !isActive ? "collapsed" : ""
            }`}
            type="button"
            onClick={() => toggleDay(index + 1)}
            style={{
              backgroundColor: "#f8f9fa",
              fontWeight: "600",
              fontSize: "1rem",
              transition: "background-color 0.3s ease",
            }}
          >
            <span>{dayItem[0]}</span>
            <span
              className={`ms-auto ${
                isActive ? "rotate-180" : ""
              } transition-transform`}
              style={{
                transition: "transform 0.3s ease",
              }}
            >
              ⌄
            </span>
          </button>
        </h2>

        <div
          className={`accordion-body-wrapper ${
            isActive ? "accordion-body-open" : ""
          }`}
        >
          <div className="accordion-body-content px-4 py-3 bg-white">
            <p className="mb-0">{dayItem[1] || "Details not available."}</p>
          </div>
        </div>
      </div>
    );
  })}
</div>

    </div>
    <div className="col-md-3 mt-4 mt-md-0">
      <div
        className="card shadow-lg border-0"
        style={{
          borderRadius: "16px",
          background: "#fff",
        }}
      >
        <div className="card-body text-center py-4 px-3">
          <h5 className="fw-bold mb-3">Need Help?</h5>
          <p className="text-muted small mb-3">
            Have questions or want to book your Ladakh biking expedition? <br />
            Call now and let our travel experts guide you every step of the way!
          </p>
          <a
            href="tel:7006363828"
            className="btn btn-dark w-100 py-2 rounded-pill"
            style={{ fontSize: "0.9rem" }}
          >
            📞 Call Now
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

      <section className="py-5 px-4 px-md-5 bg-light">
        <h3 className="h4 fw-bold mb-4">Explore More Resorts</h3>
        <div className="row g-4">
          {relatedResorts.map((hotel, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div
                className="rounded overflow-hidden h-100 d-flex flex-column"
                style={{
                  padding: "10px",
                  borderRadius: "5px"
                }}
              >
                {/* Image */}
                <div className="position-relative" style={{ height: "200px" }}>
                  <img
                    src={hotel?.image?.[0] || "/placeholder.svg?height=300&width=400"}
                    alt={hotel?.name || "Hotel"}
                    className="img-fluid w-100 h-100 object-fit-cover"
                    style={{ objectFit: "cover", borderRadius: "15px" }}
                  />
                  <div
                    className="position-absolute bottom-0 start-0 end-0 p-2 text-white"
                  >
                  </div>
                </div>

                {/* Text Content */}
                <div className="p-3 d-flex flex-column justify-content-between flex-grow-1">
                  <h6 className="fw-bold text-dark mb-2" style={{ fontSize: "1rem" }}>
                    {hotel?.name || "Unnamed Resort"}
                  </h6>
                  <p
                    className="text-muted small mb-2"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      lineHeight: "1.4",
                    }}
                  >
                    {hotel?.location || "No location provided"}
                  </p>
                  <button className="btn btn-outline-dark btn-sm mt-auto"
                    onClick={() => navigate('/HotelPackage')}>
                    View More</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <div className="container my-5">
        <div className="row align-items-center">
          {/* Left Column */}
          <div className="col-md-6 d-flex flex-column gap-3">
            <button
              onClick={() => navigate('/contact-us')}
              style={{
                width: "120px",
                height: "50px",
                borderRadius: "100px",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "#000",
                backgroundColor: "#fff",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Join Now
            </button>
            <h4 className="mb-0">Explore Leh Bike Expedition</h4>
          </div>

          {/* Right Column */}
          <div className="col-md-6">
            <p className="text-muted mb-0">
              Book your stay at Traveller Choice Ladakh—comfort, convenience, and stunning mountain views await your arrival.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-4 text-center text-muted small">
        <p>{detailData?.footerNote || 'Adventure awaits. Make your ride legendary.'}</p>
      </div>
      <TravLadhak />
      <Footer />
    </div>
  );
};

export default DetailBikePackage;